import { render, staticRenderFns } from "./addtocatalog-catalog-cell.vue?vue&type=template&id=4959b5b2&scoped=true&"
import script from "./addtocatalog-catalog-cell.vue?vue&type=script&lang=js&"
export * from "./addtocatalog-catalog-cell.vue?vue&type=script&lang=js&"
import style0 from "./addtocatalog-catalog-cell.vue?vue&type=style&index=0&id=4959b5b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4959b5b2",
  null
  
)

export default component.exports